import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class ApplicationTagFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  operationalStatusChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get operationalStatus():any {
    return this.operationalStatusChange.value;
  }
  set operationalStatus(value:any) {
    this.operationalStatusChange.next(value);
    this.emitChange("operationalStatus", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.operationalStatus && this.operationalStatus !== '') {
      params = params.set("operationalStatus", this.operationalStatus);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.operationalStatusChange.next(props.operationalStatus || undefined);
    this.descriptionChange.next(props.description || undefined);
  }

  toObj() {
    let obj:any = {};

    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.operationalStatus = this.operationalStatus;
    obj.description = this.description;
 
    return obj;
  }

  public clear():void {
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.operationalStatus = undefined;
    this.description = undefined;
  }
}
